import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameLogic } from '../Logic/PrintCardLogic';
import { PrintCardModel } from '../Models/PrintCardModel';
import { CardLabelController } from './CardLabelController';
import { CardColorController } from './CardColorController';
import { LeverController } from './LeverController';
import { AnimationContents } from '../../../../../../AnimationContents';

export class PrintCardController extends AnimationBaseController {
    $model: PrintCardModel;

    private _width: number = 0;
    private _height: number = 0;

    private _screenWidth: number = 0;
    private _screenHeight: number = 0;
    private _screenScale: number = 1;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super('PrintCardController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.PRINT_JSON,
            libraryName: 'print_card_container',
            childControllers: {
                LeverController: {
                    instanceName: '_mini_game_print_card.lever',
                    view: LeverController,
                    model: this.$model,
                },
            },
            modelWatch: {
                press: press => {
                    press === 'press_down'
                        ? this._changePressState()
                        : this.$queue.get('pressUp').addToQueue(1);
                },
                color: () => {
                    this._changeCardState();
                },
                label: () => {
                    this._changeCardState();
                },
                selectedColor: () => {
                    this._changeSeletedAnswers();
                },
                selectedLabel: () => {
                    this._changeSeletedAnswers();
                },
            },
            queue: {
                pressUp: {
                    condition: time => time > 0.3,
                    action: () => {
                        this._changePressState();
                    },
                },
            },
        };
    }

    private _changePressState() {
        this.gotoAndStopByQuery(
            '_mini_game_print_card.press',
            this.$model.press
        );
    }

    private _changeCardState() {
        this.gotoAndStopByQuery(
            '_mini_game_print_card.sample_cards',
            this.$model.color
        );
        this.gotoAndStopByQuery(
            '_mini_game_print_card.sample__logo_cards',
            this.$model.label
        );
    }

    private _changeSeletedAnswers() {
        this.gotoAndStopByQuery(
            '_mini_game_print_card.logo_card',
            this.$model.selectedLabel
        );
        this.gotoAndStopByQuery(
            '_mini_game_print_card.colors_card',
            this.$model.selectedColor
        );
    }

    protected onInitialize(): void {
        this._gameLogic.getRandomCard();
        this._changeCardState()

        this.$model.labels.forEach((label, i) => {
            this.addChildController(
                {
                    instanceName: `_mini_game_print_card.logo_card.${label}_logo`,
                    view: CardLabelController,
                    model: label,
                },
                'label_' + i
            );
        });
        this.$model.colors.forEach((color, i) => {
            this.addChildController(
                {
                    instanceName: `_mini_game_print_card.colors_card.${color}_card`,
                    view: CardColorController,
                    model: color,
                },
                'color_' + i
            );
        });

        this._width = this.display.width;
        this._height = this.display.height;
    }

    protected onResize(width: number, height: number, scale: number) {
        this._screenWidth = width;
        this._screenHeight = height;
        this._screenScale = scale;

        this.updateScale();
    }

    protected onLandscape(): void {
        this.updateScale();
    }

    protected onPortrait(): void {
        this.updateScale();
    }

    private updateScale(): void {
        this.display.scale.set(
            Math.min(
                this._screenWidth / this._width / this._screenScale,
                this._screenHeight / this._height / this._screenScale / 1.2
            )
        );
    }
}
